import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function AIChatWidget() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/admin') || location.pathname.startsWith('/tutor');

  useEffect(() => {
    const selectors = [
      'ra-assistant-widget',
      '#readdy-assistant-widget',
      '[class*="readdy-assistant"]',
      'iframe[src*="readdy.ai"]',
      '#readdy-assistant-launcher',
      '[id*="readdy-assistant"]'
    ];

    const hideWidgets = () => {
      selectors.forEach(sel => {
        const elements = document.querySelectorAll(sel);
        elements.forEach(el => {
          (el as HTMLElement).style.setProperty('display', 'none', 'important');
          (el as HTMLElement).style.setProperty('visibility', 'hidden', 'important');
          (el as HTMLElement).style.setProperty('opacity', '0', 'important');
          (el as HTMLElement).style.setProperty('pointer-events', 'none', 'important');
        });
      });
    };

    const showWidgets = () => {
      selectors.forEach(sel => {
        const elements = document.querySelectorAll(sel);
        elements.forEach(el => {
          (el as HTMLElement).style.display = 'block';
          (el as HTMLElement).style.visibility = 'visible';
          (el as HTMLElement).style.opacity = '1';
          (el as HTMLElement).style.pointerEvents = 'auto';
        });
      });
    };

    if (isDashboard) {
      document.body.classList.add('hide-chatbot-widget');
      hideWidgets();
      
      // Use a MutationObserver to ensure they stay hidden if the external script tries to re-show them
      const observer = new MutationObserver(() => {
        hideWidgets();
      });
      
      observer.observe(document.body, { childList: true, subtree: true });
      
      return () => {
        observer.disconnect();
      };
    } else {
      document.body.classList.remove('hide-chatbot-widget');
      showWidgets();
    }

    // If on the site and script not loaded yet
    if (!document.querySelector('script[src*="readdy.ai"]')) {
      const script = document.createElement('script');
      script.src = "https://readdy.ai/api/public/assistant/widget?projectId=b1692743-5ca2-4d1b-944c-338d5d2b71d9";
      script.setAttribute('mode', 'hybrid');
      script.setAttribute('voice-show-transcript', 'true');
      script.setAttribute('theme', 'light');
      script.setAttribute('size', 'compact');
      script.setAttribute('accent-color', '#059669');
      script.setAttribute('button-base-color', '#0a1a0f');
      script.setAttribute('button-accent-color', '#FFFFFF');
      script.setAttribute('main-label', 'CS Revision AI Tutor');
      script.setAttribute('empty-chat-message', "Hi! I'm your CS Revision AI Tutor. Ask me anything about GCSE or A Level Computer Science!");
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    return () => {};
  }, [isDashboard]);

  return null;
}
